import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EbrCoreModule } from 'src/app/core/components/ebr-core.module';
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressBarModule} from "@angular/material/progress-bar"
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { SolutionParticipationDetailsComponent } from './solution-participation-details.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { SolutionGroupCellComponent } from './components/solution-group-cell/solution-group-cell.component';
import { LocationComplianceCellComponent } from './components/location-compliance-cell/location-compliance-cell.component';
import { SkuGroupbyViewComponent } from './sku-groupby-view/sku-groupby-view.component';
import { SkuGroupbyProductsComponent } from './sku-groupby-products/sku-groupby-products.component';
import { CustomFilterPipe } from './pipes/custom-filter.pipe';
import { MillionPipe } from './pipes/million.pipe';
import { SolutionGroupGraphComponent } from './components/solution-group-graph/solution-group-graph.component';
import { SolutionParticipationSummaryComponent } from './components/solution-participation-summary/solution-participation-summary.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LocationDrilldownViewComponent } from './location-drilldown-view/location-drilldown-view.component';
import { ProductDetailsDrilldownViewComponent } from './product-details-drilldown-view/product-details-drilldown-view.component';
import { SharedModule } from 'src/app/shared/shared.module';
import {MatChipsModule} from '@angular/material/chips';
import { SolutionGroupsTableComponent } from './components/solution-groups-table/solution-groups-table.component';
import { WidgetGaugeChartComponent } from './components/widget-gauge-chart/widget-gauge-chart.component';
import { WidgetBarGraphComponent } from './components/widget-bar-graph/widget-bar-graph.component';
import { LocationOverviewGaugeChartComponent } from './components/location-overview-gauge-chart/location-overview-gauge-chart.component';
import { LocationTotalSolutionsGridComponent } from './components/location-total-solutions-grid/location-total-solutions-grid.component';
import { LocationProductDetailsTableComponent } from './components/location-product-details-table/location-product-details-table.component';

@NgModule({
  bootstrap: [],
  declarations: [
    SolutionParticipationDetailsComponent,
    SolutionGroupCellComponent,
    LocationComplianceCellComponent,
    SkuGroupbyViewComponent,
    SkuGroupbyProductsComponent,
    CustomFilterPipe,
    SolutionGroupGraphComponent,
    MillionPipe,
    SolutionParticipationSummaryComponent,
    LocationDrilldownViewComponent,
    ProductDetailsDrilldownViewComponent,
    SolutionGroupsTableComponent,
    WidgetGaugeChartComponent,
    WidgetBarGraphComponent,
    LocationOverviewGaugeChartComponent,
    LocationTotalSolutionsGridComponent,
    LocationProductDetailsTableComponent
  ],
  exports: [
    SolutionParticipationDetailsComponent,
  ],
  imports: [
        EbrCoreModule,
        BrowserModule,
        AppRoutingModule,
        MatSelectModule,
        MatDatepickerModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatCheckboxModule,
        NgxEchartsModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        SharedModule,
        MatChipsModule
  ],
  providers: []
})
export class SPDModule { }
